import PropTypes from "prop-types";
import { memo } from "react";
import LazyLoad from "react-lazyload";
import { FormattedMessage } from "react-intl";
import MoreDetails from "app/pages/.shared/MoreDetails.jsx";
import Video from "app/pages/.shared/Video/Video";
import Paragraphs from "app/pages/.shared/Paragraphs.jsx";
import "./activities.scss";
import { activityShape, videoPropTypes } from "app/utils/propTypes";
import Activity from "app/pages/FicheProduit/components/Activities/Activity";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const Activities = ({
	label,
	intro = [],
	facilities = [],
	activities = [],
	description,
	video = {},
	showVideo = false,
}) => {
	return (
		<div className="activities">
			{label && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL4}
					isBold
					className="activities__title"
					component="h2"
				>
					{label}
				</Typography>
			)}

			{intro && intro.length > 0 && (
				<div className="activities__intro">
					<Paragraphs paragraphs={intro} enableHTMLFormatting={true} />
				</div>
			)}

			{video.url && video.url.indexOf("http") !== -1 && showVideo && (
				<div className={!video.videoType && "activities__media"}>
					<LazyLoad once offset={300}>
						<Video {...video} />
					</LazyLoad>
				</div>
			)}

			{description && (
				<div className="activities__description">
					<Paragraphs paragraphs={description} enableHTMLFormatting />
				</div>
			)}

			{activities.map((activity, index) => {
				return (
					<div key={index} className="activities__item">
						<Activity
							label={activity.label}
							paragraphs={activity.paragraphs}
							photo={activity.photo}
						/>
					</div>
				);
			})}

			{facilities.length > 0 && (
				<div className="activities__details">
					<MoreDetails
						expandedLabel={<FormattedMessage id="product.page.less.details" />}
						collapsedLabel={<FormattedMessage id="product.page.more.details" />}
					>
						<Paragraphs paragraphs={facilities} enableHTMLFormatting />
					</MoreDetails>
				</div>
			)}
		</div>
	);
};

Activities.propTypes = {
	showVideo: PropTypes.bool,
	label: PropTypes.string,
	intro: PropTypes.arrayOf(PropTypes.string),
	description: PropTypes.string,
	facilities: PropTypes.arrayOf(PropTypes.string),
	video: videoPropTypes,
	activities: PropTypes.arrayOf(activityShape),
};

Activities.defaultProps = {
	intro: [],
	facilities: [],
	activities: [],
	video: {},
};

export default memo(Activities);
